import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { EMPTY, Observable, switchMap } from "rxjs";
import { UnitAttributes } from "src/models/units/unit-attributes.model";
import { ExternalLinksService } from "src/services/externallinks.service";
import { UnitDataService } from "src/services/unit-data.service";
import { ResolverHelper } from "./resolver.helper";

export const ExternalReportResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const queryParams = route.queryParams;
    const unitDataService = inject(UnitDataService);
    const externalLinksService = inject(ExternalLinksService);
    const authService = inject(AuthService);
    const router = inject(Router);
    const unitID: string =
        queryParams["unitID"] != null ? queryParams["unitID"].toString() : queryParams["unitId"] != null ? queryParams["unitId"].toString() : "";
    const searchString = "u" + unitID;
    const reportType = queryParams["type"];

    return unitDataService.getUnitAttributes(searchString).pipe(
        switchMap((units: UnitAttributes[]) => {
            //Søk om det finnes noen eiendom på matrikkelen
            if (units.length == 1) {
                switch (reportType) {
                    case "grunnboksutskrift":
                        redirectToLandRegistrationReport(units[0]);
                        return EMPTY;
                    case "historiskGrunnboksutskrift":
                        redirectToHistoricLandRegistrationReport(units[0]);
                        return EMPTY;
                    case "matrikkelutskrift":
                        redirectToCadastreReport(units[0]);
                        return EMPTY;
                    default:
                        return ResolverHelper.redirectToFrontPage(authService, router);
                }
            } else {
                return ResolverHelper.redirectToFrontPage(authService, router);
            }
        }),
    );

    function redirectToLandRegistrationReport(estate: UnitAttributes) {
        const url = externalLinksService.getLandRegistrationReportUrl(
            estate.municipalityNumber,
            estate.gnr,
            estate.bnr,
            estate.fnr,
            estate.snr,
            estate.organizationNumber,
            estate.shareNumber,
            false,
        );
        window.open(url, "_self");
    }

    function redirectToHistoricLandRegistrationReport(estate: UnitAttributes) {
        const url = externalLinksService.getLandRegistrationReportUrl(
            estate.municipalityNumber,
            estate.gnr,
            estate.bnr,
            estate.fnr,
            estate.snr,
            estate.organizationNumber,
            estate.shareNumber,
            true,
        );
        window.open(url, "_self");
    }

    function redirectToCadastreReport(estate: UnitAttributes) {
        const url = externalLinksService.getCadastreReportUrl(estate.municipalityNumber, estate.gnr, estate.bnr, estate.fnr, estate.snr);
        window.open(url, "_self");
    }
};
